
import { Component, input, model } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DxButtonModule, DxLookupModule, DxNumberBoxModule, DxSelectBoxModule } from 'devextreme-angular';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss',
    imports: [
    DxLookupModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxButtonModule,
    TranslatePipe
]
})
export class PaginationComponent {

    $pageSize = model<number>(12, { alias: 'pageSize' });
    $allowedPageSizes = input<number[]>([12, 24, 48], { alias: 'allowedPageSizes' });

    $pageCount = input<number>(1, { alias: 'pageCount' });
    $currentPage = model<number>(1, { alias: 'currentPage' });

    $totalRows = input<number>(0, {alias: 'totalRows'});

    prevPage() {
        let page = this.$currentPage();
        if (page > 1)
            this.$currentPage.set(--page);
    }

    nextPage() {
        let page = this.$currentPage();
        if (page < this.$pageCount())
            this.$currentPage.set(++page);
    }

}
